import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateProductRecommendations = {
  name: "generateProductRecommendations" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    maxRecommendations: z.number().optional().default(3),
  }),
  output: z.object({
    productIds: z.array(z.string()),
    source: z.enum(["ai", "fallback", "none"]),
  }),
};
